import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { NotificationOutput } from '../model/notification.output';

export interface SendMeetingAlternativeInput {
	readonly endTimestamp: number;
	readonly notificationId: string;
	readonly startTimestamp: number;
}

export interface SendMeetingAlternativeParams {
	input: SendMeetingAlternativeInput;
}

@Injectable({ providedIn: 'root' })
export class SendMeetingAlternativeApiMutation extends ApiMutation<
	NotificationOutput,
	SendMeetingAlternativeParams
> {
	client = 'messaging';
	document = gql`
		mutation SendMeetingAlternative($input: SendMeetingAlternativeInput!) {
			sendMeetingAlternative(input: $input) {
				id
				type
				taskId
				documentId
				orgModuleId
				sourceUserId
				targetUserId
				contactsName
				updateTimestamp
				creationDateTime
				meeting {
					coachId
					endDate
					startDate
				}
			}
		}
	`;
	method = 'sendMeetingAlternative';
}
